<script>
export default {
  name: "",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];

    if (val === 1) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--danger el-tag--plain"
        },
        "★"
      );
    }
    if (val === 2) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--success el-tag--plain"
        },
        "★★"
      );
    }
    if (val === 3) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--warning el-tag--plain"
        },
        "★★★"
      );
    }
    if (val === 4) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--warning el-tag--plain"
        },
        "★★★★"
      );
    }
    if (val === 5) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--success el-tag--plain"
        },
        "★★★★★"
      );
    }
    if (val === 0) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--danger el-tag--plain"
        },
        "SIN CALIFICAR"
      );
    }

    return createElement("");
  }
};
</script>
